import * as React from 'react'

import { styled } from '~/styled'

import { useBannerContext } from '../BannerContext'

const StyledBannerSlimActions = styled(
  'div',
  {
    base: ['flex', 'gap-4'],
    variants: {
      size: {
        sm: ['w-full'],
        md: ['w-auto']
      }
    }
  },
  {
    enabledResponsiveVariants: true
  }
)

export const BannerSlimActions = ({
  children,
  ...props
}: React.ComponentProps<typeof StyledBannerSlimActions>) => {
  const { size } = useBannerContext()
  return (
    <StyledBannerSlimActions size={size} {...props}>
      {children}
    </StyledBannerSlimActions>
  )
}

BannerSlimActions.displayName = 'BannerSlimActions'
